import React, { useState, useEffect } from 'react'
import classNames from "classnames/bind"

import styles from './return-to-top.module.scss';

const cx = classNames.bind(styles)

export const ReturnToTop = () => {

    const [display, setDisplay] = useState(false)

    useEffect(() => {
        window.addEventListener('scroll', (e) => handleScroll(e));
    })

    const handleScroll = (e => {
        if (window.pageYOffset > 100 && display === false) {
            setDisplay(true)
        } else if (window.pageYOffset <= 100 && display === true) {
            setDisplay(false)
        }
    })

    const scrollToTop = () => {
        if (display === true) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        }
    }

    return (
        <div className={cx('return-to-top-wrapper',
            {
                'return-fade-in': display === true,
                'return-fade-out': display === false
            }
        )} onClick={scrollToTop}>
            <span className={cx('return-to-top-image-wrapper')} title="Click to return to the top of the page">
                <img srcSet={'/images/return-to-top.svg'} alt='Return to Top'/>
            </span>
        </div>
    )
}